'use client'

import React from 'react'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { ButtonLink } from '@kiao-voice/ui-kit'

/**
 * The screen behind an aged-out preview link.
 *
 * Deliberately NOT a 404: whoever opened this link was told there is an article
 * here, and「找不到頁面」reads as「文章被刪了」. It says the link expired and points
 * at the place a fresh one is minted.
 *
 * A client component for the same reason as {@link ArticleCta}: `ButtonLink`
 * reaches the ui-kit barrel, which also exports hook-using components and
 * therefore cannot be pulled into a server component's module graph.
 */
export function PreviewExpired() {
  const { t } = useTranslation('web')
  return (
    <main className="[--container:1060px]">
      <div className="container px-0 py-24 text-center">
        <h1 className="m-0 text-[length:var(--fs-section-h2)]">{t('blog.previewExpiredTitle')}</h1>
        <p className="mx-auto mt-3 text-[length:var(--text-base)] leading-[1.75] text-[var(--muted)]">
          {t('blog.previewExpiredBody')}
        </p>
        <div className="mt-6">
          <ButtonLink as={Link} variant="secondary" href="/admin/blog">
            {t('blog.previewExpiredAction')}
          </ButtonLink>
        </div>
      </div>
    </main>
  )
}
